import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import autobind from 'react-autobind'
import { connect } from 'react-redux'
import * as actions from './../../redux/actions'
import { Redirect } from 'react-router-dom';
// import StatusBar from './../Status/StatusBar'
import { Navbar, NavbarToggler, Collapse, Nav, NavItem, DropdownMenu, Dropdown, DropdownToggle, DropdownItem } from 'reactstrap';

class SuperAdminHeader extends Component {

  constructor(props) {
    super(props);
    autobind(this);

    this.state = {
      navbarOpen: false,
      productsDropdownOpen: false,
      userDropdownOpen: false,

      // modules
      furnitureDropdownOpen: false,
      homeDecoDropdownOpen: false,
      realEstateDropdownOpen: false,
    };
  }

  componentDidMount() {
    if (this.props.impersonateEnded) {
      this.props.clearImpersonateEnd()
    }
  }

  onLogoutClick() {
    this.props.logout();
  }

  toggle(target) {
    switch (target) {
      case 'products':
        this.setState({
          productsDropdownOpen: !this.state.productsDropdownOpen,
        });
        break;

      case 'furniture':
        this.setState({
          furnitureDropdownOpen: !this.state.furnitureDropdownOpen,
        })
        break;

      case 'home_deco':
        this.setState({
          homeDecoDropdownOpen: !this.state.homeDecoDropdownOpen,
        })
        break;

      case 'real_estate':
        this.setState({
          realEstateDropdownOpen: !this.state.realEstateDropdownOpen,
        })
        break;

      case 'user':
        this.setState({
          userDropdownOpen: !this.state.userDropdownOpen
        });
        break;

      case 'navbar':
        this.setState({
          navbarOpen: !this.state.isNavbarOpen
        })
        break;

      default: break;
    }
  }

  render() {
    const { user, impersonateEnded } = this.props;

    if (!user) {
      return <Redirect to="/login" />
    }
    if (impersonateEnded) {
      return <Redirect to="/s/dashboard" />
    }
    return (
      <div>
        <Navbar className="mai-top-header navbar navbar-expand-md navbar-dark bg-faded">
          <div className="container">
            <Link to="/" className="navbar-brand"></Link>
            <NavbarToggler />
            <Collapse isOpen={this.state.navbarOpen} navbar>
              <Nav className="ml-auto nav mai-top-nav" navbar>
                <NavItem>
                  <Link to="/s/dashboard" className="nav-link">Dashboard</Link>
                </NavItem>
                <NavItem>
                  <Link to="/s/story-requests" className="nav-link">Story Requests</Link>
                </NavItem>
                {/* <NavItem>
                <Link to="/s/products" className="nav-link">Products</Link>
                </NavItem> */}
                <NavItem>
                  <Link to="/s/payments" className="nav-link">Payments</Link>
                </NavItem>
                <NavItem>
                  <Link to="/s/domains" className="nav-link">Categories</Link>
                </NavItem>
                <NavItem>
                  <Link to="/s/messages" className="nav-link">Reports</Link>
                </NavItem>
                <NavItem>
                  <Link to="/s/statistics" className="nav-link">Statistics</Link>
                </NavItem>
              </Nav>
              <Nav className="nav float-lg-right mai-user-nav" navbar>
                <Dropdown nav={true} isOpen={this.state.userDropdownOpen} toggle={() => this.toggle('user')} className="nav-item">
                  <DropdownToggle nav={true}>
                    {/* <img src="http://via.placeholder.com/30x30" alt=""/> */}
                    <span className="user-name">{user.username}</span>
                    <span className="angle-down s7-angle-down"></span>
                  </DropdownToggle>
                  <DropdownMenu>
                      <Link to="/s/settings" className="dropdown-item"><span className="icon s7-tools pr-2"> </span>Settings</Link>
                    <DropdownItem onClick={this.onLogoutClick}>Logout</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </Nav>
            </Collapse>
          </div>
        </Navbar>
      </div>
    );
  }
}

export default connect(
  (state, ownProps) => {
    const { auth: { user, error, loggingOut, impersonateEnded } } = state
    return { user, error, loggingOut, impersonateEnded }
  },
  actions,
  (stateProps, dispatchProps) => {
    return Object.assign({}, stateProps, dispatchProps)
  }
)(SuperAdminHeader)



// WEBPACK FOOTER //
// ./src/components/Header/SuperAdmin.js